export default __webpack_public_path__ + "static/media/icon-falha.f89085dc.svg";